export default __webpack_public_path__ + "static/media/about-us-1.2029ec4e.svg";